import {
  FETCH_TEAMS_REQUEST,
  FETCH_TEAMS_SUCCESS,
  FETCH_TEAMS_FAILURE,
  FETCH_TEAM_REQUEST,
  FETCH_TEAM_SUCCESS,
  FETCH_TEAM_FAILURE,
  CREATE_TEAM_REQUEST,
  CREATE_TEAM_SUCCESS,
  CREATE_TEAM_FAILURE,
  UPDATE_TEAM_REQUEST,
  UPDATE_TEAM_SUCCESS,
  UPDATE_TEAM_FAILURE,
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  FETCH_MEMBERS_REQUEST,
  FETCH_MEMBERS_SUCCESS,
  FETCH_MEMBERS_FAILURE,
  CREATE_MEMBER_REQUEST,
  CREATE_MEMBER_SUCCESS,
  CREATE_MEMBER_FAILURE,
  UPDATE_MEMBER_SUCCESS,
  UPDATE_MEMBER_REQUEST,
  UPDATE_MEMBER_FAILURE,
  DELETE_MEMBER_SUCCESS,
  DELETE_MEMBER_REQUEST,
  DELETE_MEMBER_FAILURE,
  FETCH_STATUS_REQUEST,
  FETCH_STATUS_SUCCESS,
  FETCH_STATUS_FAILURE,
  UPDATE_STATUS_REQUEST,
  UPDATE_STATUS_SUCCESS,
  UPDATE_STATUS_FAILURE,
  CREATE_SNAPSHOT_REQUEST,
  CREATE_SNAPSHOT_SUCCESS,
  CREATE_SNAPSHOT_FAILURE,
  FETCH_TEAM_ACTIVITY_REQUEST,
  FETCH_TEAM_ACTIVITY_SUCCESS,
  FETCH_TEAM_ACTIVITY_FAILURE
} from '../actions/teams';

const teams = (state = [], action) => {
  switch (action.type) {
    case FETCH_TEAMS_REQUEST:
      return {
        ...state
      };
    case FETCH_TEAMS_SUCCESS:
      return {
        ...state,
        teams: action.teams,
        error: false
      };
    case FETCH_TEAMS_FAILURE:
      return {
        ...state,
        error: true
      };
    case FETCH_TEAM_REQUEST:
      return {
        ...state,
        team: undefined
      };
    case FETCH_TEAM_SUCCESS:
      return {
        ...state,
        team: action.team,
        error: false
      };
    case FETCH_TEAM_FAILURE:
      return {
        ...state,
        error: true
      };
    case CREATE_TEAM_REQUEST:
      return {
        ...state,
        error: false
      };
    case CREATE_TEAM_SUCCESS:
      return {
        ...state,
        team: action.team,
        error: false
      };
    case CREATE_TEAM_FAILURE:
      return {
        ...state,
        error: true
      };
    case UPDATE_TEAM_REQUEST:
      return {
        ...state,
        error: false
      };
    case UPDATE_TEAM_SUCCESS:
      return {
        ...state,
        team: action.team,
        error: false
      };
    case UPDATE_TEAM_FAILURE:
      return {
        ...state,
        error: true
      };
    case FETCH_USERS_REQUEST:
      return {
        ...state,
        teams: []
      };
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        users: action.users,
        error: false
      };
    case FETCH_USERS_FAILURE:
      return {
        ...state,
        error: true
      };
    case FETCH_MEMBERS_REQUEST:
      return {
        ...state,
        teams: []
      };
    case FETCH_MEMBERS_SUCCESS:
      return {
        ...state,
        members: action.users,
        error: false
      };
    case FETCH_MEMBERS_FAILURE:
      return {
        ...state,
        error: true
      };
    case CREATE_MEMBER_REQUEST:
      return {
        ...state,
        error: false
      };
    case CREATE_MEMBER_SUCCESS:
      return {
        ...state,
        member: action.member,
        error: false
      };
    case CREATE_MEMBER_FAILURE:
      return {
        ...state,
        error: true
      };
    case UPDATE_MEMBER_REQUEST:
      return {
        ...state,
        error: false
      };
    case UPDATE_MEMBER_SUCCESS:
      return {
        ...state,
        member: action.member,
        error: false
      };
    case UPDATE_MEMBER_FAILURE:
      return {
        ...state,
        error: true
      };
    case DELETE_MEMBER_REQUEST:
      return {
        ...state,
        error: false
      };
    case DELETE_MEMBER_SUCCESS:
      return {
        ...state,
        member: action.member,
        error: false
      };
    case DELETE_MEMBER_FAILURE:
      return {
        ...state,
        error: true
      };
    case FETCH_STATUS_REQUEST:
      return {
        ...state,
        status: undefined
      };
    case FETCH_STATUS_SUCCESS:
      return {
        ...state,
        status: action.status,
        error: false
      };
    case FETCH_STATUS_FAILURE:
      return {
        ...state,
        error: true
      };
    case UPDATE_STATUS_REQUEST:
      return {
        ...state,
        status: undefined
      };
    case UPDATE_STATUS_SUCCESS:
      return {
        ...state,
        status: action.status,
        error: false
      };
    case UPDATE_STATUS_FAILURE:
      return {
        ...state,
        status: action.status,
        error: true
      };
    case CREATE_SNAPSHOT_REQUEST:
      return {
        ...state,
        snapshot: undefined
      };
    case CREATE_SNAPSHOT_SUCCESS:
      return {
        ...state,
        snapshot: action.snapshot,
        error: false
      };
    case CREATE_SNAPSHOT_FAILURE:
      return {
        ...state,
        error: true
      };
    case FETCH_TEAM_ACTIVITY_REQUEST:
      return {
        ...state
      };
    case FETCH_TEAM_ACTIVITY_SUCCESS:
      return {
        ...state,
        activity: action.activity,
        error: false
      };
    case FETCH_TEAM_ACTIVITY_FAILURE:
      return {
        ...state,
        error: true
      };
    default:
      return state;
  }
};

export default teams;



// WEBPACK FOOTER //
// ./src/reducers/teams.js